import React from 'react';
import ReactDom from 'react-dom';
import PropTypes from 'prop-types';
import PopupOverlay from '../organisms/Background/PopupOverlay';
import Avatar from '../atoms/Avatar';
import CloseButton from '../atoms/CloseButton';
import SupportAvatar from './SupportAvatar';
import './ProfilePicturePreviewModal.scss';

const ProfilePicturePreviewModal = ({ src, useSupportAvatar = false, caption, alt = 'Profile preview', onClose }) => {
    return ReactDom.createPortal(
        <PopupOverlay onClose={onClose} closeOnEsc closeOnOverlayClick>
            <div className="profile-picture-preview-modal" role="dialog" aria-modal="true">
                <CloseButton
                    className="profile-picture-preview-modal__close"
                    onClick={onClose}
                    ariaLabel="Close preview"
                />

                <div className="profile-picture-preview-modal__stage">
                    <Avatar
                        src={useSupportAvatar ? null : src}
                        alt={alt}
                        className="profile-picture-preview-modal__img"
                        fallback={useSupportAvatar ? (
                            <SupportAvatar
                                ariaLabel="Support avatar preview"
                                size={null}
                                rotateOnHover
                            />
                        ) : null}
                    />
                    {caption ? (
                        <div className="profile-picture-preview-modal__caption">{caption}</div>
                    ) : null}
                </div>
            </div>
        </PopupOverlay>,
        document.getElementById('portal') || document.body
    );
};

ProfilePicturePreviewModal.propTypes = {
    src: PropTypes.string,
    useSupportAvatar: PropTypes.bool,
    caption: PropTypes.node,
    alt: PropTypes.string,
    onClose: PropTypes.func.isRequired,
};

export default ProfilePicturePreviewModal;
